export const ownerTypeMap = {
	1: '个人',
	2: '企业'
}

export const cardType = {
	0: '未知',
	1: '居民身份证',
	2: '护照',
	3: '军官证',
	4: '台胞证',
	5: '香港身份证',
	6: '澳门身份证',
	7: '企业社会信用代码'
}
export const carOwnerInfoOptions = ownerType => {
	return ownerType && ownerType === 1
		? [
				{
					key: 'owner_type',
					label: '购车类型',
					formatFn: val => (val ? ownerTypeMap[val] : '')
				},
				{ key: 'owner_name', label: '车主姓名' },
				{ key: 'owner_id_type', label: '证件类型', formatFn: val => (val ? cardType[val] : '') },
				{ key: 'owner_id_code', label: '证件号码' },
				{ key: 'owner_phone', label: '手机号码' },
				{ key: 'registration_city_name', label: '上牌城市' }
		  ]
		: [
				{
					key: 'owner_type',
					label: '购车类型',
					formatFn: val => (val ? ownerTypeMap[val] : '')
				},
				{ key: 'owner_name', label: '车主姓名' },
				{ key: 'owner_id_type', label: '证件类型', formatFn: val => (val ? cardType[val] : '') },
				{ key: 'owner_id_code', label: '证件号码' },
				{ key: 'registration_city_name', label: '上牌城市' }
		  ]
}
